var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJaguar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 73,
    viewBox: "0 0 142 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.874 15.6543L119.519 12.1304L106.303 0.865845L94.3904 6.24812L75.1229 4.2401L78.8555 11.8548C53.0898 17.6899 28.064 24.5841 4.27625 33.4273L0.840332 37.5299C8.225 38.3174 15.6097 39.1009 22.9943 39.8884C39.0237 43.9162 53.1264 51.8853 65.306 63.7956C67.5258 66.6698 69.7456 69.5441 71.9654 72.4183L93.1743 60.8072L80.2511 50.5191L79.9544 37.9748L82.5112 48.574L94.6798 58.2086L113.31 50.9758L123.665 56.1533L130.555 49.1686L127.446 49.9521L122.123 44.6446C125.248 41.5775 129.746 39.1993 133.621 38.5891L134.534 42.8059L138.757 34.6596L141.596 32.0138L138.299 26.1393L120.874 15.6543ZM75.4855 42.1917L60.251 46.3416L76.698 37.9906L75.4855 42.1917ZM48.5549 36.6047L28.2215 31.2736C45.793 25.3204 63.3829 20.4342 81.1083 17.3474L84.5625 22.328L75.2291 22.7218L48.5549 36.6047ZM100.61 48.0031L107.79 49.5859L95.808 53.0192L87.9545 46.5424L95.9618 49.5466L113.995 32.4036L100.61 48.0031ZM115.834 24.5487L112.859 21.4933L116.772 20.9185L115.834 24.5487ZM108.145 9.66569L98.7897 12.1974L95.3355 7.2167L106.365 4.54328L116.01 13.0793L108.145 9.66569Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJaguar);
export default __webpack_public_path__ + "static/media/jaguar.8cacbf785b635fcf19bbbfdc893cde69.svg";
export { ForwardRef as ReactComponent };